import template from './table.html';
import controller from './table.controller';
import './table.scss';

let tableComponent = {
  restrict: 'E',
  bindings: {
    data: '<'
  },
  template,
  controller
};

export default tableComponent;



// WEBPACK FOOTER //
// ./client/app/components/table/table.component.js